import { render, staticRenderFns } from "./IBeaconDetailsView.vue?vue&type=template&id=10f9a9e4&scoped=true"
import script from "./IBeaconDetailsView.vue?vue&type=script&lang=js"
export * from "./IBeaconDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f9a9e4",
  null
  
)

export default component.exports